import axios from 'axios';

export function markMensajesVistos(mensajeIds) {
  return axios.post(`${window.hostname}api/property_manager/marcar_mensajes_vistos`, {
    mensaje_ids: mensajeIds
  });
}
